import { useEffect, useRef, useState } from 'react';

export function useScrollReveal(options = {}) {
  const {
    rootMargin = '0px',
    threshold = 0.01,
  } = options;
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { rootMargin, threshold });

    observer.observe(node);

    return () => observer.disconnect();
  }, [rootMargin, threshold]);

  return [ref, isVisible];
}

export function revealFromX(isVisible, direction = 'left', delay = 0) {
  const offset = direction === 'right' ? 72 : -72;

  return {
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'translateX(0)' : `translateX(${offset}px)`,
    transition: `opacity 0.85s ease ${delay}ms, transform 0.85s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
    willChange: isVisible ? 'auto' : 'opacity, transform',
    '@media (prefers-reduced-motion: reduce)': {
      opacity: 1,
      transform: 'none',
      transition: 'none',
      willChange: 'auto',
    },
  };
}
